
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { AlertCircle } from 'lucide-react';
import { FormStepProps } from '../types';

const AlarmRulesStep: React.FC<FormStepProps> = ({ formData, handleChange, errors = {} }) => {
  return (
    <div className="space-y-6">
      <div className="flex items-center p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg mb-4">
        <AlertCircle className="h-5 w-5 text-blue-500 mr-2" />
        <p className="text-sm text-blue-700 dark:text-blue-300">Configure alarm rules to get notifications when device readings exceed thresholds</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <Label htmlFor="alarmThreshold">Alarm Threshold</Label>
          <Input
            id="alarmThreshold"
            name="alarmThreshold"
            value={formData.alarmThreshold}
            onChange={handleChange}
            placeholder="e.g. 90% capacity"
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="notificationEmail">Notification Email</Label>
          <Input
            id="notificationEmail"
            name="notificationEmail"
            value={formData.notificationEmail}
            onChange={handleChange}
            placeholder="Enter email for notifications"
            type="email"
            className={errors.notificationEmail ? "border-red-500" : ""}
          />
          {errors.notificationEmail && (
            <p className="text-xs text-red-500 mt-1">{errors.notificationEmail}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AlarmRulesStep;
